/* RC UI: adds the progress line under every .rc-swipe row on a phone (see rc-ui.css). ~1KB, deferred. */
(function () {
  var mq = window.matchMedia('(max-width: 767.98px)');
  function setup(el) {
    if (el._sb) return;
    var bar = document.createElement('div'); bar.className = 'rc-sbar'; bar.setAttribute('aria-hidden', 'true'); bar.innerHTML = '<i></i>';
    el.insertAdjacentElement('afterend', bar); el._sb = bar;
    var th = bar.firstChild;
    function upd() {
      var o = el.scrollWidth - el.clientWidth;
      if (o <= 4 || !mq.matches) { bar.style.display = 'none'; return; }
      bar.style.display = 'block';
      var tw = Math.max(0.15, el.clientWidth / el.scrollWidth);
      th.style.width = (tw * 100) + '%';
      th.style.transform = 'translateX(' + (el.scrollLeft / o * (1 - tw) * bar.clientWidth) + 'px)';
    }
    el.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd); upd(); setTimeout(upd, 600);
  }
  function init() { document.querySelectorAll('.rc-swipe').forEach(setup); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
})();
